(function () {
  var elements = document.querySelectorAll('.pr-reveal');
  if (!elements.length) return;

  // The reveal replays, but only on the way down. Coming back up a section is
  // already in place and stays there -- re-animating what the reader has
  // already seen reads as a glitch rather than an entrance.
  //
  // No scroll-direction tracking is needed for that: where a section is when it
  // leaves the viewport says everything. Scrolling down carries it out of the
  // TOP, and it keeps its revealed state, so scrolling back up finds it already
  // there. Only once it has fallen back out of the BOTTOM -- meaning the reader
  // has scrolled up past it entirely -- is it reset, off-screen and unseen,
  // ready to rise again on the next pass down.
  //
  // Crossing 10% is what reveals, the trigger point the original one-shot
  // version used. The reset deliberately waits for the section to leave
  // completely, so a section taller than the window -- whose visible fraction
  // can sit under 10% the whole way through -- cannot fade out mid-scroll.
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.intersectionRatio >= 0.1) {
          entry.target.classList.add('pr-reveal--visible');
          return;
        }
        if (entry.isIntersecting) return;
        var viewportBottom = entry.rootBounds ? entry.rootBounds.bottom : window.innerHeight;
        if (entry.boundingClientRect.top >= viewportBottom) {
          entry.target.classList.remove('pr-reveal--visible');
        }
      });
    },
    { threshold: [0, 0.1] }
  );

  elements.forEach(function (element) {
    observer.observe(element);
  });
})();
